import { useEffect, useState } from 'react';
import { asyncGetPqrSurvey } from '../../../../../services/pqr.service';
import { useNavigate, useParams } from 'react-router-dom';
import { Pqr } from '../../../../../shared/types/modules/pqr';
import { ACCOUNTS } from '../../../../../routes/paths';
import { useFormik } from 'formik';
import { ISelect } from '../../../../../shared/types/shared';

export const useSurveyDetail = () => {
    const navigate = useNavigate();
    const { idPqr } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqr, setPqr] = useState<Pqr>();
    const [halfName, setHalfName] = useState<string>();

    const formik = useFormik({
        initialValues: {
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            question9: '',
            question10: '',
            question11: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        if (Boolean(idPqr?.trim())) {
            setLoading(true);
            asyncGetPqrSurvey(idPqr?.trim())
                .then((pqr) => {
                    console.log(pqr);
                    if (pqr) setPqr(pqr);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqr]);

    useEffect(() => {
        formik.setValues({
            question1: pqr?.survey?.question1 || '',
            question2: pqr?.survey?.question2 || '',
            question3: pqr?.survey?.question3 || '',
            question4: pqr?.survey?.question4 || '',
            question5: pqr?.survey?.question5 || '',
            question6: pqr?.survey?.question6 || '',
            question7: pqr?.survey?.question7 || '',
            question8: pqr?.survey?.question8 || '',
            question9: pqr?.survey?.question9 || '',
            question10: pqr?.survey?.question10 || '',
            question11: pqr?.survey?.question11 || '',
        });
        setHalfName((pqr?.data?.half as ISelect)?.name);
    }, [pqr]);

    return { loading, formik, halfName, pqr };
};
